module.exports = __webpack_public_path__ + "fonts/gotham_bold.eaee103.otf";